import styled from "@emotion/styled";

export const StopDetailsContainer = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	justifyContent: "space-between",
	marginBottom: "24px",
	gap: "16px",
	">span": {
		...theme.project.typography.overline,
		color: theme.project.colors.fontColors.main,
		justifySelf: "flex-end",
		alignSelf: "center"
	},
	[theme.breakpoints.down("md")]: {
		flexDirection: "column",
		">span": {
			alignSelf: "flex-start"
		}
	}
}));

export const StopNumber = styled.div(({ theme }) => ({
	...theme.project.typography.subtitle.subtitle2,
	color: theme.project.colors.fontColors.secondary
}));

export const StopAddress = styled.div(({ theme }) => ({
	...theme.project.typography.body.body2,
	color: theme.project.colors.fontColors.main
}));
